module.exports = __webpack_public_path__ + "img/banner.847b5724.jpg";